import { translate } from '@portal/services/i18n';
import React from 'react';
import CurrencyInputMask from 'react-currency-input';

interface ValueRequestedProps {
  value: string;
  onChange: (value: string, rawValue: number) => void;
}

const ValueRequested = ({ onChange, value }: ValueRequestedProps) => (
  <div className="value-requested">
    <CurrencyInputMask
      className="value-requested__currency-mask-input"
      autoFocus
      value={value}
      onChange={onChange}
      decimalSeparator={translate('SHARED.CURRENCY.DECIMAL_SEPARATOR')}
      thousandSeparator={translate('SHARED.CURRENCY.THOUSAND_SEPARATOR')}
      prefix={translate('SHARED.CURRENCY.SYMBOL')}
    />
  </div>
);

export default ValueRequested;
